//@flow
/* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

const lercv2BaseProps2 = [
    'raster-domain-max',
    'raster-domain-min',
    'raster-colorscale', // è¿ä¸ªéè¦æ¯DataDrivenå±æ§
    'lerc-clamp-low',
    'lerc-clamp-high',
    'clamp-high-value',
    'clamp-low-value',
    'lerc-include',
    'lerc-exclude',
    'geojson-mask-source',
    'image-geojson-mask',
];

const lercv2BaseProps = [
    'lerc-mask-source',
    'lerc-mask-include',
    'lerc-mask-exclude',
    ...lercv2BaseProps2
];


const lercv2Props = [
    'is-image',
    'mask-color',
    'mask-mix',
    'invalid-color',
    ...lercv2BaseProps,
];
const lercOverlayLayerProps = [
    'lerc-mask-source-1',
    'lerc-mask-source-2',
    'lerc-mask-source-3',
    'lerc-mask-source-4',
    // 'lerc-mask-source-5',
    'lerc-mask-include-1',
    'lerc-mask-include-2',
    'lerc-mask-include-3',
    'lerc-mask-include-4',
    // 'lerc-mask-include-5',
    'lerc-mask-exclude-1',
    'lerc-mask-exclude-2',
    'lerc-mask-exclude-3',
    'lerc-mask-exclude-4',
    // 'lerc-mask-exclude-5',
    ...lercv2BaseProps2,
];
const lerc3dLayerProps = [
    'pixels',
    'height-base',
    'height-factor',
    'texture-source',
    'texture-type',
    'raster-domain-max',
    'raster-domain-min',
    'raster-colorscale',
    'vertex-type',
    'clamp-high-value',
    'clamp-low-value',
];
const lercTerrainLayerProps = [
    'draw-type',
    'zenith',
    'azimuth',
    ...lercv2BaseProps,
];
const lercCompareLayerProps = [
    'appear-color',
    'disappear-color',
    'same-color',
    'diff-color',
    'increase-color',
    'decrease-color',
    'diff-range-min',
    'diff-range-max',
    'draw-type',
    'lerc-compare-source',
    ...lercv2BaseProps,
];

const lercGridProps = [
    'scale',
    'opacity',
    'min',
    'max',
    'density',
    'baseValue',
];

const gagoLayers = [
    {
        name: 'lercv2',
        customProps: lercv2Props,
    },
    {
        name: 'lerc-overlay',
        customProps: lercOverlayLayerProps,
    },
    {
        name: 'lerc-3d',
        customProps: lerc3dLayerProps,
    },
    {
        name: 'lerc-terrain',
        customProps: lercTerrainLayerProps,
    },
    {
        name: 'lerc-compare',
        customProps: lercCompareLayerProps,
    },
    {
        name: "lerc-grid",
        customProps: lercGridProps,
    }
];
const { createLercLayer } = require('./lerc_style_layer');
exports.gagoLayers = gagoLayers;
exports.modifyStyleLayers = function(StyleLayer) {
    gagoLayers.forEach(({ name, customProps }) => {
        const LercClass = createLercLayer(name, customProps, StyleLayer);
        StyleLayer.setLayer(name, LercClass);
    });
};
